import Vue from 'vue'
import Router from 'vue-router'
import  WJWList from '@/components/WJWList.vue'
import  WJWVedioList from '@/components/WJWVedioList.vue'
import  wifiSet from '@/components/wifiSet.vue'
import  RegDataGet from '@/components/RegDataGet.vue'
import  PiIndex from '@/components/PiIndex.vue'
import  PrintClear  from '@/components/PrintClear.vue'
import  GetPrintCode  from '@/components/GetPrintCode.vue'
import  GSJS  from  '@/components/GSJS.vue'
import  QYZP  from  '@/components/QYZP.vue'


GetPrintCode
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'WJWList',
      component: WJWList
    },
    {
      path: '/vedio',
      name: 'WJWVedioList',
      component: WJWVedioList
    },
    {
      path: '/wifiset',
      name: 'wifiSet',
      component: wifiSet
    },
    {
      path: '/regdataget',
      name: 'RegDataGet',
      component: RegDataGet
    },
    {
      path: '/piindex',
      name: 'PiIndex',
      component: PiIndex
    },
    {
      path: '/printclear',
      name: 'PrintClear',
      component: PrintClear
    },
    {
      path: '/getprintcode',
      name: 'GetPrintCode',
      component: GetPrintCode
    },
    {
      path: '/gsjs',
      name: 'GSJS',
      component: GSJS
    },
    {
      path: '/qyzp',
      name: 'QYZP',
      component: QYZP
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js